(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apiculture-responsable"] && !Shopify.designMode) return;
  try {
    
  /* Check if mobile */
  let width = window.innerWidth;

  if (width < 750) {
    console.log('Mobile');
    let carrousel = document.querySelector('.apiculture-responsable .carrousel-box');
    document
      .querySelector('.card1')
      .querySelectorAll('.img-box img')
      .forEach((element) => {
        element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-blanche.svg');
      });
    carrousel.addEventListener('scroll', function (e) {
      let card1 = document.querySelector('.card1');
      let card2 = document.querySelector('.card2');
      let card3 = document.querySelector('.card3');
      let width = card1.offsetWidth;
      let selected = document.querySelector('.selected');

      if (carrousel.scrollLeft > width / 2) {
        if (carrousel.scrollLeft > width) {
          selected.classList.remove('selected');
          selected.querySelectorAll('.img-box img').forEach((element) => {
            element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-noire.svg');
          });
          card3.classList.add('selected');
          card3.querySelectorAll('.img-box img').forEach((element) => {
            element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-blanche.svg');
          });
        } else {
          selected.classList.remove('selected');
          selected.querySelectorAll('.img-box img').forEach((element) => {
            element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-noire.svg');
          });
          card2.classList.add('selected');
          card2.querySelectorAll('.img-box img').forEach((element) => {
            element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-blanche.svg');
          });
        }
      } else {
        selected.classList.remove('selected');
        selected.querySelectorAll('.img-box img').forEach((element) => {
          element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-noire.svg');
        });
        card1.classList.add('selected');
        card1.querySelectorAll('.img-box img').forEach((element) => {
          element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-blanche.svg');
        });
      }
    });
  } else {
    console.log('Desktop');
    let cards = document.querySelectorAll('.card');
    cards.forEach((element) => {
      element.addEventListener('mouseenter', function (e) {
        e.target.querySelectorAll('.img-box img').forEach((element) => {
          element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-blanche.svg');
        });
        element.addEventListener('mouseleave', function (e) {
          e.target.querySelectorAll('.img-box img').forEach((element) => {
            element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/coche-noire.svg');
          });
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["avis"] && !Shopify.designMode) return;
  try {
    
  /* Faire un tableau avec différents avis puis en sélectionner 3 aléatoirement et remplir les 3 cartes */
  function getRandomInt(max) {
    return Math.floor(Math.random() * max);
  }

  let avis = [
    [
      'Je recommande vivement !',
      'Un miel délicieux et très parfumé. Un régal. Merci !',
      'Marie R.',
      'Miel de Tilleul Liquide, 1kg',
      5,
    ],
    [
      'Des miels de qualité !',
      'Une valeur sûre ! Agréablement surpris par le Miel de Fenouil !',
      'Anne L.',
      'Miel de Fenouil, 500g',
      5,
    ],
    ['Colis très bien emballé !', 'Excellents produits... Un vrai régal !', 'Patrick', 'Mielonoisette, 240g', 5],
    ['Délicieux', 'Je suis un fana du Miel de Fenouil et de Sarrasin !', 'Marc', 'Miel de Fenouil, 250g', 5],
    ['Miels excellents !', 'Bien oncteux !', 'Christelle', 'Miel de Forêt crémeux, 250g', 5],
    [
      'Très bons !',
      'Très bons produits. Très bien emballé. Suivi de la commande parfait.',
      'Christian',
      'Miel de Tilleul, 500g',
      5,
    ],
    [
      'Très sérieux !',
      'Producteur très sérieux et honnête. Produits excellents et très variés. Emballages soignés et livraison à la date convenue. Merci.',
      'Michelle',
      "Miel d'Acacia, 500g",
      5,
    ],
    [
      'Très bons produits !',
      'Je recommande le Mielonoisette et le Miel de Fenouil ! Saveur inédite pour du miel. Merci pour cette découverte.',
      'Quentin',
      'Mielonoisette, 240g',
      5,
    ],
    ['Trop bon !', 'Produits de qualité. Bravo.', 'Patricia', 'Confiture de Framboise au Miel, 230g', 5],
    [
      'Tout simplement parfait !',
      'Le miel est délicieux et super onctueux avec goût délicat à souhait. Je recommande !',
      'Sandrine',
      'Miel de Tilleul, 500g',
      5,
    ],
    ['Parfait !', "Un miel qui sort de l'ordinaire. Merci beaucoup !", 'Marc', 'Miel de Sarrasin, 250g', 5],
    [
      'Excellent !',
      "L'emballage était très soigné. Nous avons gouté le miel de tilleul et nous l'avons trouvé excellent.",
      'Martine & Serge',
      'Miel de Tilleul, 500g',
      5,
    ],
    [
      'Superbe !',
      'Les confitures sont excellentes. Le goût est fin et la texture parfaite. Bravo.',
      'Christophe',
      'Velours de Cassis au Miel, 240g',
      5,
    ],
    ['Tout est parfait !', 'Les miels et les confitures sont excellents !', 'Anna', 'Miel de Sarrasin, 250g', 4],
    [
      'Très satisfaite',
      'Très satisfaite des produits commandés. Je recommande ce producteur.',
      'Nathalie',
      "Savon Miel-Propolis-Cire d'abeille, 100g",
      5,
    ],
  ];

  let max = avis.length;

  let avis1 = getRandomInt(max);
  let avis2 = getRandomInt(max);
  while (avis2 == avis1) {
    //console.log("Ah l'avis 2 était le même que l'avis 1, on va refaire, c'était : ", avis2);
    avis2 = getRandomInt(max);
  }
  let avis3 = getRandomInt(max);
  while (avis3 == avis2 || avis3 == avis1) {
    //console.log("Ah l'avis 3 était le même que l'avis 1 ou 2, on va refaire, c'était : ", avis3);
    avis3 = getRandomInt(max);
  }

  /*console.log('Avis 1 : ');
  console.log('Titre : ', avis[avis1][0]);
  console.log('Commentaire : ', avis[avis1][1]);
  console.log('Nom : ', avis[avis1][2]);
  console.log('Achat : ', avis[avis1][3]);
  console.log('Note : ', avis[avis1][4]);

  console.log('Avis 1 : ', avis[avis1][0], avis[avis1][1], avis[avis1][2], avis[avis1][3], avis[avis1][4]);
  console.log('Avis 2 : ', avis[avis2][1]);
  console.log('Avis 3 : ', avis[avis3][1]);*/

  /*console.log('Avis : ', avis);
  console.log('Longueur du tableau : ', max);
  console.log('Random : ', random);
  console.log('3eme array avis : ', avis[2]);
  console.log('1st cell 3eme array avis : ', avis[2][0]);
  console.log("Array d'avis random : ", avis[random]);
  console.log("Cell d'array d'avis random : ", avis[random][1]);*/

  /* Remplissage des cartes avis */
  /* Desktop */
  if (window.innerWidth >= 750) {
    /* Commentaire 1 */
    let commentaire1Title = document.querySelector('.avis-desktop .carrousel-box .carte.commentaire1 h3');
    let commentaire1Comment = document.querySelector('.avis-desktop .carrousel-box .carte.commentaire1 p');
    let commentaire1Nom = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire1 .left-section .nom'
    );
    let commentaire1Produit = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire1 .left-section .produit'
    );
    let commentaire1Note = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire1 .right-section > span'
    );
    commentaire1Title.innerHTML = '" ' + avis[avis1][0] + ' "';
    commentaire1Comment.innerHTML = avis[avis1][1];
    commentaire1Nom.innerHTML = avis[avis1][2];
    commentaire1Produit.innerHTML = avis[avis1][3];
    commentaire1Note.innerHTML = avis[avis1][4] + '/5';
    if (avis[avis1][4] == 4) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 3) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 2) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 1) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li:nth-child(2) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 0) {
      document
        .querySelectorAll('.avis-desktop .carrousel-box .bottom.commentaire1 .right-section ul li img')
        .forEach((element) => {
          element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
        });
    }

    /* Commentaire 2 */
    let commentaire2Title = document.querySelector('.avis-desktop .carrousel-box .carte.commentaire2  h3');
    let commentaire2Comment = document.querySelector('.avis-desktop .carrousel-box .carte.commentaire2  p');
    let commentaire2Nom = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire2 .left-section .nom'
    );
    let commentaire2Produit = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire2 .left-section .produit'
    );
    let commentaire2Note = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire2 .right-section > span'
    );
    commentaire2Title.innerHTML = '" ' + avis[avis2][0] + ' "';
    commentaire2Comment.innerHTML = avis[avis2][1];
    commentaire2Nom.innerHTML = avis[avis2][2];
    commentaire2Produit.innerHTML = avis[avis2][3];
    commentaire2Note.innerHTML = avis[avis2][4] + '/5';
    if (avis[avis2][4] == 4) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 3) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 2) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 1) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li:nth-child(2) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 0) {
      document
        .querySelectorAll('.avis-desktop .carrousel-box .bottom.commentaire2 .right-section ul li img')
        .forEach((element) => {
          element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
        });
    }

    /* Commentaire 3 */
    let commentaire3Title = document.querySelector('.avis-desktop .carrousel-box .carte.commentaire3 h3');
    let commentaire3Comment = document.querySelector('.avis-desktop .carrousel-box .carte.commentaire3 p');
    let commentaire3Nom = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire3 .left-section .nom'
    );
    let commentaire3Produit = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire3 .left-section .produit'
    );
    let commentaire3Note = document.querySelector(
      '.avis-desktop .carrousel-box .bottom.commentaire3 .right-section > span'
    );
    commentaire3Title.innerHTML = '" ' + avis[avis3][0] + ' "';
    commentaire3Comment.innerHTML = avis[avis3][1];
    commentaire3Nom.innerHTML = avis[avis3][2];
    commentaire3Produit.innerHTML = avis[avis3][3];
    commentaire3Note.innerHTML = avis[avis3][4] + '/5';
    if (avis[avis3][4] == 4) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 3) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 2) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 1) {
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li:nth-child(2) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 0) {
      document
        .querySelectorAll('.avis-desktop .carrousel-box .bottom.commentaire3 .right-section ul li img')
        .forEach((element) => {
          element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
        });
    }
  } else if (window.innerWidth <= 749) {
    /* Mobile */
    /* Commentaire 1 */
    let commentaire1Title = document.querySelector('.avis .carrousel-box .commentaire1.carte-commentaire.carte h3');
    let commentaire1Comment = document.querySelector('.avis .carrousel-box .commentaire1.carte-commentaire.carte p');
    let commentaire1Nom = document.querySelector('.avis .carrousel-box .commentaire1.bottom .nom');
    let commentaire1Produit = document.querySelector('.avis .carrousel-box .commentaire1.bottom .produit');
    let commentaire1Note = document.querySelector('.avis .carrousel-box .commentaire1.bottom .note > span');
    commentaire1Title.innerHTML = '" ' + avis[avis1][0] + ' "';
    commentaire1Comment.innerHTML = avis[avis1][1];
    commentaire1Nom.innerHTML = avis[avis1][2];
    commentaire1Produit.innerHTML = avis[avis1][3];
    commentaire1Note.innerHTML = avis[avis1][4] + '/5';
    if (avis[avis1][4] == 4) {
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 3) {
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 2) {
      document
        .querySelector(
          '.avis .carrousel-box .commentaire1.bottom .note ul li.avis .carrousel-box .commentaire1 .note ul li:last-child img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector(
          '.avis .carrousel-box .commentaire1.bottom .note ul li.avis .carrousel-box .commentaire1 .note ul li:nth-child(4) img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector(
          '.avis .carrousel-box .commentaire1.bottom .note ul li.avis .carrousel-box .commentaire1 .note ul li:nth-child(3) img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 1) {
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire1.bottom .note ul li:nth-child(2) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis1][4] == 0) {
      document.querySelectorAll('.avis .carrousel-box .commentaire1.bottom .note ul li img').forEach((element) => {
        element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      });
    }

    /* Commentaire 2 */
    let commentaire2Title = document.querySelector('.avis .carrousel-box .commentaire2.carte-commentaire.carte h3');
    let commentaire2Comment = document.querySelector('.avis .carrousel-box .commentaire2.carte-commentaire.carte p');
    let commentaire2Nom = document.querySelector('.avis .carrousel-box .commentaire2.bottom .nom');
    let commentaire2Produit = document.querySelector('.avis .carrousel-box .commentaire2.bottom .produit');
    let commentaire2Note = document.querySelector('.avis .carrousel-box .commentaire2.bottom .note > span');
    commentaire2Title.innerHTML = '" ' + avis[avis2][0] + ' "';
    commentaire2Comment.innerHTML = avis[avis2][1];
    commentaire2Nom.innerHTML = avis[avis2][2];
    commentaire2Produit.innerHTML = avis[avis2][3];
    commentaire2Note.innerHTML = avis[avis2][4] + '/5';
    if (avis[avis2][4] == 4) {
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 3) {
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 2) {
      document
        .querySelector(
          '.avis .carrousel-box .commentaire2.bottom .note ul li.avis .carrousel-box .commentaire2 .note ul li:last-child img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector(
          '.avis .carrousel-box .commentaire2.bottom .note ul li.avis .carrousel-box .commentaire2 .note ul li:nth-child(4) img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector(
          '.avis .carrousel-box .commentaire2.bottom .note ul li.avis .carrousel-box .commentaire2 .note ul li:nth-child(3) img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 1) {
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire2.bottom .note ul li:nth-child(2) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis2][4] == 0) {
      document.querySelectorAll('.avis .carrousel-box .commentaire2.bottom .note ul li img').forEach((element) => {
        element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      });
    }

    /* Commentaire 3 */
    let commentaire3Title = document.querySelector('.avis .carrousel-box .commentaire3.carte-commentaire.carte h3');
    let commentaire3Comment = document.querySelector('.avis .carrousel-box .commentaire3.carte-commentaire.carte p');
    let commentaire3Nom = document.querySelector('.avis .carrousel-box .commentaire3.bottom .nom');
    let commentaire3Produit = document.querySelector('.avis .carrousel-box .commentaire3.bottom .produit');
    let commentaire3Note = document.querySelector('.avis .carrousel-box .commentaire3.bottom .note > span');
    commentaire3Title.innerHTML = '" ' + avis[avis3][0] + ' "';
    commentaire3Comment.innerHTML = avis[avis3][1];
    commentaire3Nom.innerHTML = avis[avis3][2];
    commentaire3Produit.innerHTML = avis[avis3][3];
    commentaire3Note.innerHTML = avis[avis3][4] + '/5';
    if (avis[avis3][4] == 4) {
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 3) {
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 2) {
      document
        .querySelector(
          '.avis .carrousel-box .commentaire3.bottom .note ul li.avis .carrousel-box .commentaire2 .note ul li:last-child img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector(
          '.avis .carrousel-box .commentaire3.bottom .note ul li.avis .carrousel-box .commentaire2 .note ul li:nth-child(4) img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector(
          '.avis .carrousel-box .commentaire3.bottom .note ul li.avis .carrousel-box .commentaire2 .note ul li:nth-child(3) img'
        )
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 1) {
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:last-child img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:nth-child(4) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:nth-child(3) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      document
        .querySelector('.avis .carrousel-box .commentaire3.bottom .note ul li:nth-child(2) img')
        .setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
    }
    if (avis[avis3][4] == 0) {
      document.querySelectorAll('.avis .carrousel-box .commentaire3.bottom .note ul li img').forEach((element) => {
        element.setAttribute('src', '//lesruchersdenormandie.myshopify.com/cdn/shop/t/3/assets/etoile-grise.svg');
      });
    }
  }

  /* Carte focus change on mobile */
  if (window.innerWidth <= 749) {
    let carrousel = document.querySelector('.avis .carrousel-box');
    carrousel.addEventListener('scroll', function (e) {
      console.log('scroll');
      let carte1 = document.querySelector('.carte-commentaire.commentaire1.carte');
      let carte2 = document.querySelector('.carte-commentaire.commentaire2.carte');
      let carte3 = document.querySelector('.carte-commentaire.commentaire3.carte');
      let width = carte1.offsetWidth;
      let selected = document.querySelector('.selected');

      if (carrousel.scrollLeft > width / 2) {
        if (carrousel.scrollLeft > width) {
          selected.classList.remove('selected');
          carte3.classList.add('selected');
        } else {
          selected.classList.remove('selected');
          carte2.classList.add('selected');
        }
      } else {
        selected.classList.remove('selected');
        carte1.classList.add('selected');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  let tiroirs = document.querySelector('.tiroirs');
  tiroirs.addEventListener('click', (e) => {
    if (e.target.classList.contains('question')) {
      let question = e.target;
      let answer = question.parentNode.querySelector('.answer');
      if (answer.classList.contains('hidden')) {
        answer.classList.remove('hidden');
        let arrow = question.querySelector('img');
        arrow.style.transform = 'rotate(180deg)';
      } else {
        answer.classList.add('hidden');
        let arrow = question.querySelector('img');
        arrow.style.transform = 'rotate(0deg)';
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight + 56}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  let isDesktop = window.innerWidth >= 750;
  if (isDesktop) {
    menuLink = document.querySelector('.header__icon--menu');
    menuDrawer = document.querySelector('.menu-drawer-desktop');
    menuLink.addEventListener('click', function () {
      if (menuLink.classList.contains('menu-open')) {
        menuLink.classList.remove('menu-open');
        menuDrawer.classList.remove('open');
      } else {
        menuLink.classList.add('menu-open');
        menuDrawer.classList.add('open');
      }
    });
    menuDrawer.addEventListener('click', function (event) {
      const link = event.target.closest('a[href*="#"]');
      if (!link) return;

      menuLink.classList.remove('menu-open');
      menuDrawer.classList.remove('open');
    });
  }

  const mobileHeaderDrawer = document.querySelector('header-drawer');
  const mobileMenu = mobileHeaderDrawer?.querySelector('#menu-drawer');

  mobileMenu?.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('a[href*="#"]');
    if (!link) return;

    mobileHeaderDrawer.closeMenuDrawer(event, mobileHeaderDrawer.querySelector('summary'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-banner"] && !Shopify.designMode) return;
  try {
    
  if (window.innerWidth >= 750) {
    window.onload = function () {
      document.querySelector('.shopify-section .banner .banner__media').style.opacity = 1;
      setTimeout(() => {
        document.querySelector('.shopify-section .banner .banner__content').style.paddingTop = '240px';
      }, 0.4);
    };
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-alt"] && !Shopify.designMode) return;
  try {
    
  console.log(window.innerWidth);
  if (window.innerWidth > 749) {
    let products = document.querySelectorAll('.grid__item');
    console.log(products.length);
    let div = document.createElement('div');
    let div2 = document.createElement('div');
    let div3 = document.createElement('div');
    let div4 = document.createElement('div');
    div.classList.add('empty-box');
    div2.classList.add('empty-box');
    div3.classList.add('empty-box');
    div4.classList.add('empty-box');
    products[2].before(div);
    products[8].before(div2);
    products[8].before(div3);
    products[14].before(div4);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    
  // Get pro tag
  let is_company_tag = document.querySelector('.if-company-field.tag');

  let companyNameField = document.querySelector('.if-company-field:has(#RegisterForm-CompanyName)');
  let APECodeField = document.querySelector('.if-company-field:has(#RegisterForm-APECode)');
  let SIRETField = document.querySelector('.if-company-field:has(#RegisterForm-SIRET)');

  companyNameField.remove();
  APECodeField.remove();
  SIRETField.remove();

  let emailField = document.querySelector('.field:has(#RegisterForm-email)');

  // Check pro checkbox
  let is_company_checkbox = document.querySelector('.checkbox-field input');
  is_company_checkbox.addEventListener('change', function () {
    if (this.checked) {
      is_company_tag.setAttribute('value', 'Professionnel');
      emailField.after(SIRETField);
      emailField.after(APECodeField);
      emailField.after(companyNameField);
    } else {
      is_company_tag.removeAttribute('value');
      companyNameField.remove();
      APECodeField.remove();
      SIRETField.remove();
    }
  });

  // Bloquer le spam
  document.addEventListener('DOMContentLoaded', function () {
    const form = document.querySelector('#create_customer');

    if (!form) return;

    form.addEventListener('submit', function (event) {
      const websiteField = form.querySelector('#website');

      if (websiteField && websiteField.value.trim() !== '') {
        event.preventDefault();
        event.stopPropagation();

        console.warn('Bot détecté via le honeypot.');

        form.reset();

        return false;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
